import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment';
import { ComplexBuildingCategoryModel } from './../models/complex-building-category.model';
import { ComplexMunicipalityModel } from './../models/complex-municipality.model';
import { LocalCacheService } from './local-cache.service';

@Injectable({
  providedIn: 'root',
})
export class BuildingCategoryService {
  apiUrl = '/api/v1/buildingCategory';

  constructor(
    private http: HttpClient,
    private localCacheService: LocalCacheService
  ) {
    if (environment.production || environment.test) {
      this.apiUrl = `${environment.bffUrl}${this.apiUrl}`;
    }
  }

  getAll(): Observable<ComplexBuildingCategoryModel> {
    return this.http.get<ComplexMunicipalityModel>(`${this.apiUrl}`);
  }
}
